export default {info: 'glyphicon glyphicon-info-sign',success: 'glyphicon glyphicon-ok-sign',warning: 'glyphicon glyphicon-exclamation-sign',danger: 'glyphicon glyphicon-remove-sign'
};
